var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23437 8.70717C6.11427 8.8573 5.88594 8.8573 5.76585 8.70717L2.39003 4.48741C2.23289 4.29098 2.37274 4 2.62429 4L9.37592 4C9.62747 4 9.76732 4.29098 9.61018 4.48741L6.23437 8.70717Z",
    fill: "#4E5969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDown);
export default __webpack_public_path__ + "static/media/gray-down.3ffb2ae7f1163cd2cd84a4343e1adff1.svg";
export { ForwardRef as ReactComponent };